import { render, staticRenderFns } from "./CheckoutShippingEdit.vue?vue&type=template&id=490c5c9a&"
import script from "./CheckoutShippingEdit.vue?vue&type=script&lang=js&"
export * from "./CheckoutShippingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports